import React from 'react';
import { Link } from 'react-router-dom';

const Clinic404 = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '400px', textAlign: 'center' }}>
            <div style={{ fontSize: '6rem', fontWeight: 'bold', color: 'var(--primary-color)', marginBottom: '1rem' }}>
                404
            </div>
            <h2 style={{ marginBottom: '1rem' }}>Page Not Found</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: '2rem', maxWidth: '500px' }}>
                The page you are looking for doesn't exist or has been moved. Please check the URL or navigate back to the home page.
            </p>
            <Link
                to="/"
                className="btn btn-outline-secondary"
            >
                Back to Home
            </Link>
        </div>
    );
};

export default Clinic404;
